import { useScreenSize } from '@hooks';
import { Flex, theme, Typography } from '@styles';
import { arrayOf, number, string } from 'prop-types';
import React from 'react';
import { useDrag } from 'react-dnd';

const Card = ({ droppedCardIds, height, id, text, type }) => {
  const { isTabletSM } = useScreenSize();

  const isDropped = droppedCardIds?.includes(id);
  const [{ isDragging }, drag] = useDrag(
    () => ({
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
      item: () => {
        if (navigator.vibrate) {
          navigator.vibrate(200);
        }

        return { id, text };
      },
      type,
    }),
    [text, type, id]
  );

  return (
    <Flex
      ref={drag}
      alignItems="center"
      backgroundColor={theme.colors.hunterGreen[90]}
      borderColor={theme.colors.whiteLine[20]}
      borderStyle="solid"
      borderWidth={1}
      flex={1}
      justifyContent="center"
      minHeight={height || 148}
      opacity={isDragging || isDropped ? 0.2 : 1}
      px={isTabletSM ? '8px' : 24}
      py={isTabletSM ? 16 : 24}
      style={{
        pointerEvents: isDropped ? 'none' : 'auto',
        userSelect: 'none',
      }}
    >
      <Typography
        color={theme.colors.white[100]}
        textAlign="center"
        variant={isTabletSM ? 'MS-regular-s16-lh25' : 'MS-semibold-s18-lh27'}
      >
        {text}
      </Typography>
    </Flex>
  );
};

Card.propTypes = {
  droppedCardIds: arrayOf(number).isRequired,
  height: number,
  id: number.isRequired,
  text: string.isRequired,
  type: string.isRequired,
};

Card.defaultProps = {
  height: null,
};

export default Card;
